import React from 'react';
import { bool, oneOf } from 'prop-types';
import { ProductAddonsTooltip } from '../../common/ProductAddOnsTooltip';

const tooltipContent = (
  <div className="sui-p-2 sui-w-96" data-component="VirtualAssistanceTooltip">
    <div className="sui-pb-3 sui-leading-loose">
      <p>What can we help you with?</p>
      <ul className="sui-list-disc sui-ml-4 sui-pl-3">
        <li>Available styles</li>
        <li>How to measure</li>
        <li>Custom door/window designs</li>
        <li>Pro orders</li>
        <li>Installation</li>
      </ul>
    </div>
    <ol className="sui-ml-4 sui-list-decimal sui-leading-relaxed">
      <li className="sui-pb-3">
        <p className="sui-font-bold">Call now or Request a free virtual appointment</p>
        <p>
          Call 1-833-HDAPRON (432-7766) Monday - Friday from 9 a.m - 11 p.m EST &amp; Saturday - Sunday
          from 9 a.m - 9 p.m EST, or request a free
          virtual appointment to schedule a time to speak with a door and window associate.
        </p>
      </li>
      <li className="sui-pb-3">
        <p className="sui-font-bold">Speak with an associate</p>
        <p>
          How can we help? Whether you have questions about product availability or features or
          need a quote for a custom door or window solution, we&apos;ve got you covered.
        </p>
      </li>
      <li className="sui-pb-3">
        <p className="sui-font-bold">We&apos;ll follow up</p>
        <p>We&apos;ll make sure you have everything you need for your project!</p>
      </li>
    </ol>
  </div>
);

const toiletVirtualAssistancePopoverContent = ({
  channel,
}) => {
  return (
    <div
      className="product-add-on-tooltip-content product-add-on-tooltip-content__toilet-virtual-assistance-content"
      data-component="ToiletVirtualAssistanceTooltip"
      data-channel={channel}
    >
      <div className="product-add-on-tooltip-content__body">
        After you discuss your project and pay an installation fee,
        a professional will call you back within one business day
        to schedule your installation.
      </div>

      <div className="product-add-on-tooltip-content__sub-heading"><b>What You Get</b></div>

      <ul className="product-add-on-tooltip-content__list">
        <li key="0">Haul away and removal of old toilet</li>
        <li key="1">New toilet installed with all the supplies necessary
          including flange bolts, wax rings and supply line
        </li>
        <li key="2">Clean up</li>
      </ul>

      <div className="product-add-on-tooltip-content__disclaimer">
        *Pricing varies depending on size of project or code regulation requirements.
        Items delivered from the store incur an additional fee.
        Specialized installs (concealed p-traps and those requiring electrical work) do not qualify.
      </div>
    </div>
  );
};

const VirtualAssistanceTooltip = ({ checked, isToiletVirtualAssistance, channel }) => {
  return (
    <div>
      <ProductAddonsTooltip
        tooltipContent={isToiletVirtualAssistance ? toiletVirtualAssistancePopoverContent({ channel }) : tooltipContent}
        checked={checked}
        title={isToiletVirtualAssistance ? 'How it Works' : 'HOW IT WORKS'}
        zIndexClassName={isToiletVirtualAssistance ? 'sui-z-max' : 'sui-z-10'}
        isToiletVirtualAssistance={isToiletVirtualAssistance}
      />
    </div>
  );
};

VirtualAssistanceTooltip.displayName = 'ProductAddOns-virtual-assistance-tooltip';

VirtualAssistanceTooltip.propTypes = {
  /** Whether or not the checkbox is checked  */
  checked: bool,
  /** Whether or not this is for toilet virtual assistance */
  isToiletVirtualAssistance: bool,
  /** Channel will be mobile if mobile */
  channel: oneOf(['desktop', 'mobile']),
};

VirtualAssistanceTooltip.defaultProps = {
  checked: false,
  isToiletVirtualAssistance: false,
  channel: 'desktop',
};

export { VirtualAssistanceTooltip };